import React, { useState, useMemo } from 'react';
import AuthContext from '@contexts/AuthContext';
import { isLoggedIn } from '@utilities';
import { removeItems } from '@utilities/local-storage';
import { useAppSelector } from '@store/selectors';
import AppRoutes from '@utilities/app-routes';

const AuthProvider = ({ children }: Record<string, any>) => {
	const [loggedIn, setLoggedIn] = useState(isLoggedIn());
	const [user, setUser] = useState<any>(useAppSelector(state => state.user.user));
	const { loading: isUserLoading, userPermissionsList: permissions } = useAppSelector(state => state.user);

	const login = () => {
		setLoggedIn(true);
	};
	const logout = () => {
		removeItems();
		setUser(null);
		window.location.href = AppRoutes.LOGIN;
	};

	const hasPermission = (perm?: string) => {
		if (!perm) return true;
		return permissions.some(p => p.permission === perm && p.isAssigned);
	};

	const value = useMemo(() => {
		return {
			isUserLoading,
			user,
			setUser,
			loggedIn,
			login,
			logout,
			permissions: permissions.map(p => p.permission),
			hasPermission
		};
	}, [user, loggedIn, permissions, hasPermission]);

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
